
import { Component, OnInit } from '@angular/core';
import { CompletionStat, HeygenStat, TextToSpeechStat, UsageStat } from '@shared/index';
import dayjs from 'dayjs';
import { CardModule } from 'primeng/card';
import { MessageModule } from 'primeng/message';
import { RouteShareService } from 'src/app/shared/services/route-share.service';
import { ManualLinkComponent } from "../../../../../../shared/components/rag-admin/manual-link/manual-link.component";
import { StatisticService } from './statistic.service';
import { Month, MonthOfYear, StatisticsMonthSelectorComponent } from './statistics-month-selector/statistics-month-selector.component';
import { UsageStatisticChartComponent } from './usage-statistic-chart/usage-statistic-chart.component';

@Component({
  imports: [
    StatisticsMonthSelectorComponent,
    UsageStatisticChartComponent,
    ManualLinkComponent,
    CardModule,
    MessageModule
  ],
  templateUrl: './statistics-tab.component.html',
  styleUrl: './statistics-tab.component.scss'
})
export class StatisticsTabComponent implements OnInit {

  public isThisBotUnused: boolean = false;
  public usageStats: UsageStat[] = [];
  public filteredUsageStats?: {
    all: UsageStat[]
    GPT41: CompletionStat[]
    GPT4O: CompletionStat[]
    GPT4OMINI: CompletionStat[]
    GPT41MINI: CompletionStat[]
    GPT41NANO: CompletionStat[]
    GPT5: CompletionStat[]
    GPT5MINI: CompletionStat[]
    GPT5NANO: CompletionStat[]
    GPT51: CompletionStat[]
    GPT52: CompletionStat[]
    GPT54: CompletionStat[]
    GPT54MINI: CompletionStat[]
    GPT54NANO: CompletionStat[]
    GPT55: CompletionStat[]
    GPT55PRO: CompletionStat[]
    GPT56: CompletionStat[]
    GPT56SOL: CompletionStat[]
    GPT56TERRA: CompletionStat[]
    GPT56LUNA: CompletionStat[]
    GPT6ASTRA: CompletionStat[]
    DEEPSEEKR18B: CompletionStat[]
    DEEPSEEKR114B: CompletionStat[]
    GEMMA34B: CompletionStat[]
    LLAMA323B: CompletionStat[]
    MISTRAL7B: CompletionStat[]
    QWEN25VL7B: CompletionStat[]
    HEYGEN: HeygenStat[]
    TTS: TextToSpeechStat[]
    GPTTTS: TextToSpeechStat[]
  };



  public firstMonth: MonthOfYear = {
    month: dayjs().get("month") + 1 as Month,
    year: dayjs().get("year")
  };
  public lastMonth: MonthOfYear = {
    month: dayjs().get("month") + 1 as Month,
    year: dayjs().get("year")
  };
  public selectedMonth: MonthOfYear = {
    month: dayjs().get("month") + 1 as Month,
    year: dayjs().get("year")
  };

  constructor(
    public statService: StatisticService,
    public rss: RouteShareService
  ) { }

  public async ngOnInit(): Promise<void> {
    this.usageStats = await this.statService.getStatistics(this.rss.botConfig._id);
    const lastIndex = this.usageStats.length - 1;
    if (this.usageStats.length === 0 || !this.usageStats[0] || !this.usageStats[lastIndex]) {
      this.isThisBotUnused = true;
      return;
    }
    this.usageStats.sort((a, b) => {
      return dayjs(a.created).isAfter(dayjs(b.created)) ? 1 : -1;
    });
    this.firstMonth = {
      year: dayjs(this.usageStats[0].created).get("year"),
      month: dayjs(this.usageStats[0].created).get("month") + 1 as Month
    };
    this.lastMonth = {
      year: dayjs(this.usageStats[lastIndex].created).get("year"),
      month: dayjs(this.usageStats[lastIndex].created).get("month") + 1 as Month
    };
    this.computeFilteredUsage();
  }

  public computeFilteredUsage() {
    const monthFiltered = this.usageStats.filter((stat) => dayjs(stat.created).get("month") + 1 === this.selectedMonth.month && dayjs(stat.created).get("year") === this.selectedMonth.year);
    this.filteredUsageStats = {
      all: monthFiltered,
      GPT4O: monthFiltered.filter((stat) => stat.model === 'gpt-4o') as CompletionStat[],
      GPT4OMINI: monthFiltered.filter((stat) => stat.model === 'gpt-4o-mini') as CompletionStat[],
      GPT41: monthFiltered.filter((stat) => stat.model === 'gpt-4.1') as CompletionStat[],
      GPT41MINI: monthFiltered.filter((stat) => stat.model === 'gpt-4.1-mini') as CompletionStat[],
      GPT41NANO: monthFiltered.filter((stat) => stat.model === 'gpt-4.1-nano') as CompletionStat[],
      GPT5: monthFiltered.filter((stat) => stat.model === 'gpt-5') as CompletionStat[],
      GPT5MINI: monthFiltered.filter((stat) => stat.model === 'gpt-5-mini') as CompletionStat[],
      GPT5NANO: monthFiltered.filter((stat) => stat.model === 'gpt-5-nano') as CompletionStat[],
      GPT51: monthFiltered.filter((stat) => stat.model === 'gpt-5.1') as CompletionStat[],
      GPT52: monthFiltered.filter((stat) => stat.model === 'gpt-5.2') as CompletionStat[],
      GPT54: monthFiltered.filter((stat) => stat.model === 'gpt-5.4') as CompletionStat[],
      GPT54MINI: monthFiltered.filter((stat) => stat.model === 'gpt-5.4-mini') as CompletionStat[],
      GPT54NANO: monthFiltered.filter((stat) => stat.model === 'gpt-5.4-nano') as CompletionStat[],
      GPT55: monthFiltered.filter((stat) => stat.model === 'gpt-5.5') as CompletionStat[],
      GPT55PRO: monthFiltered.filter((stat) => stat.model === 'gpt-5.5-pro') as CompletionStat[],
      GPT56: monthFiltered.filter((stat) => stat.model === 'gpt-5.6') as CompletionStat[],
      GPT56SOL: monthFiltered.filter((stat) => stat.model === 'gpt-5.6-sol') as CompletionStat[],
      GPT56TERRA: monthFiltered.filter((stat) => stat.model === 'gpt-5.6-terra') as CompletionStat[],
      GPT56LUNA: monthFiltered.filter((stat) => stat.model === 'gpt-5.6-luna') as CompletionStat[],
      GPT6ASTRA: monthFiltered.filter((stat) => stat.model === 'gpt-6-astra') as CompletionStat[],
      DEEPSEEKR18B: monthFiltered.filter((stat) => stat.model === 'deepseek-r1:8b') as CompletionStat[],
      DEEPSEEKR114B: monthFiltered.filter((stat) => stat.model === 'deepseek-r1:14b') as CompletionStat[],
      GEMMA34B: monthFiltered.filter((stat) => stat.model === 'gemma3:4b') as CompletionStat[],
      LLAMA323B: monthFiltered.filter((stat) => stat.model === 'llama3.2:3b') as CompletionStat[],
      MISTRAL7B: monthFiltered.filter((stat) => stat.model === 'mistral:7b') as CompletionStat[],
      QWEN25VL7B: monthFiltered.filter((stat) => stat.model === 'qwen2.5vl:7b') as CompletionStat[],
      HEYGEN: monthFiltered.filter((stat) => stat.model === 'heygen_streaming_avatar'),
      TTS: monthFiltered.filter((stat) => stat.model === 'tts-1') as TextToSpeechStat[],
      GPTTTS: monthFiltered.filter((stat) => stat.model === 'gpt-4o-mini-tts') as TextToSpeechStat[]
    };
  }
}
